import React from 'react';

class HierarchyFieldSelectorPreview extends React.Component {
  render() {
    return (
      <div className='HierarchyFieldSelectorPreview'>
        {' '}
        {this.props.values.map((i, index) => {
          return (
            <If
              key={index}
              condition={this.props.opened.indexOf(index) > -1}
            >
              <If condition={_.first(this.props.opened) !== index}>{' > '}</If>
              {i.label}
            </If>
          );
        })}{' '}
      </div>
    );
  }
}

module.exports = HierarchyFieldSelectorPreview;
